import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { NewStudentEmailModal } from "../components/NewStudentEmailModal";

const NewStudents = () => {
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  
  useEffect(() => {
    document.title = "New Student Guide – OFUESI";
    const desc = "New to the US? Get connected with OFUESI regional fellowships and support.";
    let meta = document.querySelector('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "description");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", desc);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <section className="bg-gradient-to-br from-ministry-cyan via-primary to-ministry-cyan py-16">
        <div className="container mx-auto px-4 text-center text-white">
          <h1 className="text-4xl lg:text-6xl font-bold">New Student Guide</h1>
          <p className="text-blue-100 mt-4 max-w-2xl mx-auto">
            Welcome to the United States! Find a Christ-centered community near your campus and get practical help
            settling in.
          </p>
          <div className="mt-6 flex gap-4 justify-center">
            <Button
              asChild
              className="border-white text-white hover:bg-white hover:text-primary hover:border-primary hover:border-2"
            >
              <Link to="/regions">Find Your Region</Link>
            </Button>
            <Button
              className="border-white text-white hover:bg-white hover:text-primary hover:border-primary hover:border-2"
              onClick={() => setEmailModalOpen(true)}
            >
              Email Us
            </Button>
          </div>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4 grid gap-6 md:grid-cols-3">
          <Card>
            <CardHeader>
              <CardTitle>Get Connected</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 text-muted-foreground">
              <p>Reach your regional coordinator for rides, housing tips, and campus fellowship times.</p>
              <Button
                asChild
                className="border-white text-white hover:bg-white hover:text-primary hover:border-primary hover:border-2"
              >
                <Link to="/regions">Browse Regions</Link>
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Prayer & Support</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 text-muted-foreground">
              <p>We would love to pray for you. Share your needs or praise reports.</p>
              <Button
                asChild
                className="border-white text-white hover:bg-white hover:text-primary hover:border-primary hover:border-2"
              >
                <Link to="/prayer">Prayer Map</Link>
              </Button>
            </CardContent>
          </Card>

          <Card>
            <CardHeader>
              <CardTitle>Ask Anything</CardTitle>
            </CardHeader>
            <CardContent className="space-y-3 text-muted-foreground">
              <p>Use the chat widget to ask questions about regions, events, or how to connect.</p>
              <p className="text-sm">Bottom-right chat bubble.</p>
            </CardContent>
          </Card>
        </div>
      </section>

      <NewStudentEmailModal open={emailModalOpen} onOpenChange={setEmailModalOpen} />
    </div>
  );
};

export default NewStudents;
